import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { COMPANY, CONTACT, BRANCHES, DIVISIONS } from '../mock';
import { ENQUIRY_TEAMS, getEnquiryMailto } from '../lib/enquiries';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-24 relative overflow-hidden">
      <div className="footer-watermark">FIXED</div>
      <div className="fx-container py-16 md:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 relative">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/fixed-logo.svg" alt="Fixed Group" className="h-12 w-auto" />
            <div className="font-extrabold text-white text-lg">Fixed° Group</div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">Refrigerated container repair, cold-chain logistics, and cold room solutions across Malaysia since {COMPANY.established}.</p>

        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-emerald-400">Home</Link></li>
            <li><Link to="/about" className="hover:text-emerald-400">About Us</Link></li>
            <li><Link to="/services" className="hover:text-emerald-400">Services</Link></li>
            <li><Link to="/divisions" className="hover:text-emerald-400">Divisions</Link></li>
            <li><Link to="/gallery" className="hover:text-emerald-400">Gallery</Link></li>
            <li><Link to="/contact" className="hover:text-emerald-400">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Our Divisions</h4>
          <ul className="space-y-2 text-sm">
            {DIVISIONS.map(d => (
              <li key={d.slug}><Link to={`/divisions/${d.slug}`} className="hover:text-emerald-400">{d.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3"><MapPin size={16} className="text-emerald-400 mt-0.5" /><span>{BRANCHES[0].address}</span></li>
            <li className="flex items-start gap-3"><Phone size={16} className="text-emerald-400 mt-0.5" /><span className="flex flex-col gap-1">{CONTACT.phones.map((p) => (<a key={p.tel} href={`tel:${p.tel}`} className="hover:text-emerald-400">{p.display}</a>))}</span></li>
            <li className="flex items-start gap-3"><Mail size={16} className="text-emerald-400 mt-0.5 shrink-0" /><div className="min-w-0 space-y-3">{ENQUIRY_TEAMS.map(team => <div key={team.id}><span className="block text-xs text-slate-400">{team.label} enquiries</span><a href={getEnquiryMailto(team.id)} className="break-all hover:text-emerald-400">{team.email}</a></div>)}</div></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="fx-container py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Fixed Group. All rights reserved.</div>
          <div>Designed for the Fixed Group of companies.</div>
        </div>
      </div>
    </footer>
  );
}
